module.exports = {"141122100":"天宁镇","141122101":"夏家营镇","141122102":"西营镇","141122103":"水峪贯镇","141122104":"西社镇","141122105":"庞泉沟镇","141122200":"洪相乡","141122201":"岭底乡","141122202":"东坡底乡","141122203":"会立乡","141122400":"夏家营生态工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141122.json
// module id = 338
// module chunks = 0